const Images_Exported = {
  bookAvailabile: require("./flat-design-woman-character-isolated.png"),
  resume_pages: {
    page_1: require("./SandeepResume-1.jpg"),
    page_2: require("./SandeepResume-2.jpg"),
    page_3: require("./SandeepResume-3.jpg"),
    page_4: require("./SandeepResume-4.jpg"),
    page_5: require("./SandeepResume-5.jpg"),
  },
  resumedoc: require('../Pictures/resumedoc.docx'),
  resumepdf: require('../Pictures/SandeepResume.pdf'),
  
};
export default Images_Exported;
